// @flow
import get from 'lodash/get';
import type { JobsQuery, JobsFilters } from '../../types';

function mapFilters(filters): JobsFilters {
  return {
    region: filters.region,
    city: filters.city,
    distance: filters.distance,
    salaryMin: filters.salary_min,
    salaryMax: filters.salary_max,
    category: filters.category,
    company: filters.company,
    jobType: filters.job_type,
    workingHours: filters.working_hours,
    experienceMin: filters.experience_min,
  };
}

function mapSearch(what, where): string {
  return [what, where].filter(Boolean).join(' ');
}

export default function(apiSearchNotification: Object): JobsQuery {
  const verticalProperties = get(apiSearchNotification, 'attributes.query.vertical_properties', {});
  const filters = get(apiSearchNotification, 'attributes.query.filters', {});
  const what = get(apiSearchNotification, 'attributes.query.what', '');
  const where = verticalProperties.where;

  return {
    search: mapSearch(what, where),
    verticalProperties: {
      // No type id for jobs
    },
    filters: mapFilters(filters),
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/shared/SearchNotifications/adapters/subscriptionQueryMapper/jobsQueryMapper.js